export default __webpack_public_path__ + "static/media/7.e0a99004.jpg";